import {
  HelseregistreJSProject,
  DirekteinnsynJSProject,
  ForskningJSProject,
  RegisterinnsynJSProject,
  TestRegisterinnsynProject,
} from '../types/project-name-constant';
import type { HNDirekteinnsynJS, HNForskningJS, HNHelseregistreJS, HNRegisterinnsynJS, HNTestRegisterinnsynJS } from '../types/Resources';

import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { createResourcesApi } from '@helsenorge/framework-utils/resources';

import direkteInnsynTekst from './HN.Direkteinnsyn.JS.nb-NO.json';
import forskningsTekster from './HN.Forskning.JS.nb-NO.json';
import helseregisterTekster from './HN.Helseregistre.JS.nb-NO.json';
import registerinnsynTekster from './HN.Registerinnsyn.JS.nb-NO.json';
import testRegisterInnsynTekster from './HN.TestRegisterinnsyn.JS.nb-NO.json';

type HelseregistreSOTGrupper = HNDirekteinnsynJS | HNHelseregistreJS | HNRegisterinnsynJS | HNTestRegisterinnsynJS | HNForskningJS;

const getBundledResources = (projectName: string, language: LanguageLocales): HelseregistreSOTGrupper | undefined => {
  if (language === LanguageLocales.NORWEGIAN) {
    switch (projectName) {
      case HelseregistreJSProject:
        return helseregisterTekster;
      case RegisterinnsynJSProject:
        return registerinnsynTekster;
      case ForskningJSProject:
        return forskningsTekster;
      case DirekteinnsynJSProject:
        return direkteInnsynTekst;
      case TestRegisterinnsynProject:
        return testRegisterInnsynTekster;
      default:
        break;
    }
  }
};

const fetchResources = async (projectName: string, language: LanguageLocales): Promise<HelseregistreSOTGrupper> => {
  try {
    const resources = await import(`./${projectName}.${language}.json`);

    return resources.default;
  } catch (error) {
    throw new Error(`Failed to load resources for ${projectName} in ${language}: ${error}`);
  }
};

export const { resourcesApi, useResources, useSuspenseResources } = createResourcesApi<HelseregistreSOTGrupper>({
  fallbackLanguage: LanguageLocales.NORWEGIAN,
  getBundledResources: getBundledResources,
  fetchResources: fetchResources,
  useFallbackForMissingTexts: true,
});
